import AdsFaqList from "../../components/ad/Faq/AdsFaqList";

export const AdsFaqPage = () => {

    return (
        <AdsFaqList />
    )
}